import type Alpine from "alpinejs";

/**
 * Fade the fixed vertical social rail out as the footer enters viewport.
 * Targets `.rail-social` (singleton) and `.site-footer`.
 */
export function registerSocialRail(_A: typeof Alpine) {
  const start = () => {
    const rail = document.querySelector<HTMLElement>(".rail-social");
    const footer = document.querySelector<HTMLElement>(".site-footer");
    if (!rail || !footer || !("IntersectionObserver" in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          rail.classList.toggle("is-hidden", e.isIntersecting);
        }
      },
      { rootMargin: "-200px 0px 0px 0px", threshold: 0 },
    );
    io.observe(footer);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
}
